import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, ListGroup, ListGroupItem, FormGroup, Label, Input, Spinner } from 'reactstrap';
import moment from 'moment';

import Timer from '../../components/Timer';

import actions from './actions';

class ListaSolicitacoes extends Component {
  constructor (props) {
    super(props);

    this.state = {
      filter: {},
      timer: false
    };
  }

  componentDidMount () {
    this.load();
  }

  handleAction (type, value) {
    return () => {
      let { onChangeSituacaoSolicitacaoAguaMineral, onLoadListaSolicitacoes, onLoadConsumoAguaMineralPorCompetenciaIfNeeded } = this.props.actions;
      onChangeSituacaoSolicitacaoAguaMineral(type, value)
      .then(onLoadListaSolicitacoes)
      .then(() => {
        if ('entrega' === type) {
          return onLoadConsumoAguaMineralPorCompetenciaIfNeeded();
        }
      });
    };
  }

  toggleFilter (index) {
    return () => {
      this.setState(state => ({
        filter: {
          ...state.filter,
          [index]: !state.filter[index]
        }
      }));
    };
  }

  componentWillUnmount () {
    clearTimeout(this.timer);
  }

  load = () => {
    this.props.actions.onLoadListaSolicitacoes().then(() => {
      this.setState({last: new Date()});
    });
  };
  
  reload = () => {
    this.load();
    this.timer = setTimeout(this.reload, 900000);
  };

  toggleReloadTimer = () => {
    this.setState(state => {
      clearTimeout(this.timer);

      let s = !state.timer;

      if (s) {
        this.reload();
      }

      return {
        timer: s
      };
    });
  };

  render() {
    const { value: { result, fetching } } = this.props;
    const { last } = this.state;

    const filteredItems = result
    .filter(v => !v.entrega || !v.confirmacao);

    return (
      <Fragment><ListGroup>
        <ListGroupItem>
        {[
          ["entrega", "Exibir entregas da última semana"]
        ].map((v, i) => (
          <FormGroup key={i} check inline className="d-flex justify-content-between align-items-center">
            <Label check>
              <Input
                type="checkbox"
                onChange={this.toggleFilter(v[0])}
                checked={!!this.state.filter[v[0]]}
              />{' ' + v[1]}
            </Label>
            {!i && <Button style={{textDecoration:"none"}} color="link" size="sm" onClick={this.toggleReloadTimer}><Timer value={last} unit="minutes" />m <span className={"fa fa-sync" + (1 === fetching?" fa-spin":"")} /></Button>}
          </FormGroup>
        ))}
        </ListGroupItem>
        {2 === fetching && 0 === filteredItems.length && <ListGroupItem color="success">Não há solicitações pendentes.</ListGroupItem>}
        {filteredItems
        .map(v => (
          <ListGroupItem key={v.id} color={v.confirmacao && !v.entrega?'info':''} className="d-flex justify-content-between align-items-center">
            {v.unidade} : {moment(v.data_solicitacao).calendar()} - {v.nome_produto}
            {[
              [!v.confirmacao, "Confirmar solicitação", "confirmacao", "fa fa-handshake", "Confirmar!"],
              [!v.entrega && v.confirmacao, "Registrar entrega", "entrega", "fa fa-motorcycle", "Entregar!"],
            ].map((button, i) => button[0] && (<Button key={i} disabled={1 === v.fetching} color="success" title={button[1]} onClick={this.handleAction(button[2], v)}>
              {1 === v.fetching?<Spinner size="sm" />:<span className={button[3]} />}
              {' '}<span className="d-none d-sm-inline-block">{button[4]}</span>
            </Button>))}
          </ListGroupItem>
        ))}
        {1 === fetching && <ListGroupItem color="secondary"><Spinner size="sm" color="dark" /> Carregando...</ListGroupItem>}
        {this.state.filter.entrega && Object.values(result
        .filter(v => v.entrega)
        .reduce((s, v) => {
          let key = moment(v.data_solicitacao).format('YYYY-MM-DD');
          if (!(key in s)) {
            s[key] = {
              label: moment(key).calendar(null, {
                lastDay : '[Ontem]',
                sameDay : '[Hoje]',
                nextDay : '[Amanhã]',
                lastWeek : 'dddd',
                nextWeek : 'L',
                sameElse : 'L'
              }),
              entregas: []
            };
          }
          s[key].entregas.push(v);

          return s;
        }, {}))
        .map((v, i) => (
          <ListGroupItem key={i}>
            <details>
              <summary className="d-flex justify-content-between align-items-center">{v.label}<span>{v.entregas.length}</span></summary>
              <ul>
                {v.entregas.map(v => (
                  <li key={v.id}>{v.unidade} : {moment(v.data_solicitacao).format("HH:mm")} - {v.nome_produto}</li>
                ))}
              </ul>
            </details>
          </ListGroupItem>
        ))
        }
      </ListGroup><br /></Fragment>
    );
  }
}

let mapStateToProps = ({ consumo: { solicitacoes } }) => ({
  value: solicitacoes
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaSolicitacoes);



// WEBPACK FOOTER //
// ./src/modules/aguaMineral/ListaSolicitacoes.js